import { useEffect, useState } from 'react';
import { getPdfData } from 'views/utils/download';
import { IssuanceDocumentType } from 'views/utils/enums';
export const useSymbolApplyConfirm = (applicationID: string) => {
  const [isChecked, setIsChecked] = useState<boolean>(false);
  const [isScrolledSalesContractPdf, setIsScrolledSalesContractPdf] = useState<boolean>(false);
  const [isScrolledTransferConsentRequestPdf, setIsScrolledTransferConsentRequestPdf] = useState<boolean>(false);
  const [SalesContractPdfData, setSalesContractPDFData] = useState<string>();
  const [TransferConsentRequestPdfData, setTransferConsentRequestPDFData] = useState<string>();

  useEffect(() => {
    getPdfData({
      ApplicationFileData: {
        ApplicationID: applicationID ?? '' ,
        FileType: IssuanceDocumentType.SalesContract ,
      }
    }).then((data) => {
      setSalesContractPDFData(data);
    });

    getPdfData({
      ApplicationFileData: {
        ApplicationID: applicationID ?? '' ,
        FileType: IssuanceDocumentType.TransferConsentRequest ,
      }
    }).then((data) => {
      setTransferConsentRequestPDFData(data);
    });
  }, []);
  const checkProps = {
    checked: isChecked,  
    onChange: () => {setIsChecked(!isChecked)},
  }

  return {
    checkProps,
    isDisabled : !(isChecked && isScrolledSalesContractPdf && isScrolledTransferConsentRequestPdf),
    setIsScrolledSalesContractPdf,
    setIsScrolledTransferConsentRequestPdf,
    SalesContractPdfData,
    TransferConsentRequestPdfData,
  };
};
